exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-tree-item[data-v-cfd6dc98] {\n  background: #fff;\n  margin: 0.041667rem 0;\n  padding: 0.0625rem;\n}\nul[data-v-cfd6dc98] {\n  list-style: none;\n  user-select: none;\n}", ""]);

// exports
